import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, of, switchMap } from 'rxjs';
import { AgentsService } from '../../core/services/agents.service';
import { AGENTS_API_ACTIONS, CONVERSATION_DETAILS_API_ACTIONS } from '../actions';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { CONVERSATION_DATA_REDUCER } from '../reducers/conversation-data.reducer';
import { APPLICATION_REDUCER } from '../reducers/application.reducer';

@Injectable()
export class AgentsEffects {
  constructor(
    private readonly agentsService: AgentsService,
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  fetchAgents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONVERSATION_DETAILS_API_ACTIONS.success),
      map(() => AGENTS_API_ACTIONS.get()),
    );
  });

  getAgents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AGENTS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(CONVERSATION_DATA_REDUCER.siteId).pipe(filter(Boolean))),
      switchMap(([, siteId]) =>
        this.agentsService.getAgents(siteId).pipe(
          map((response) => AGENTS_API_ACTIONS.getSuccess(response)),
          catchError((error: HttpErrorResponse) => of(AGENTS_API_ACTIONS.error(error))),
        ),
      ),
    );
  });

  assignAgentToCall$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AGENTS_API_ACTIONS.update),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectCallDetailId)),
      switchMap(([agent, callDetailRecordId]) =>
        this.agentsService.assignAgentToCall([{ agentId: agent.agentId, callDetailRecordId }]).pipe(
          map(() => AGENTS_API_ACTIONS.updateSuccess(agent)),
          catchError((error: HttpErrorResponse) => of(AGENTS_API_ACTIONS.error(error))),
        ),
      ),
    );
  });
}
